import { send } from 'server';

export const validateChallengeAnswer = ({ responseToken, operation }) => send({
    ID: 35655,
    responses: [35656, 35657],
    description: 'Validate challenge answer',
    responseToken,
    operation
});
